declare global {
    interface Window {
        // requestIdleCallback: (
        //     callback: (deadline: RequestIdleCallbackDeadline) => void,
        //     opts?: RequestIdleCallbackOptions
        // ) => RequestIdleCallbackHandle;
        // cancelIdleCallback: (handle: RequestIdleCallbackHandle) => void;
    }
}

export type RequestIdleCallbackHandle = any;

export interface RequestIdleCallbackOptions {
    timeout: number;
}

export interface RequestIdleCallbackDeadline {
    readonly didTimeout: boolean;
    timeRemaining: () => number;
}

export const requestIdleCallback =
    typeof window !== 'undefined'
        ? window.requestIdleCallback ||
          function (cb: (data: any) => void) {
              const start = Date.now();
              return setTimeout(() => {
                  cb({
                      didTimeout: false,
                      timeRemaining() {
                          return Math.max(0, 50 - (Date.now() - start));
                      }
                  });
              }, 1);
          }
        : () => {};

export const cancelIdleCallback = typeof window !== 'undefined' ? window.cancelIdleCallback || clearTimeout : () => {};
